import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import Subtext from 'shared/components/Subtext'
import { getPxAsRem } from 'shared/utils'

import type { ReactNode } from 'react'

interface Props {
    additionalInfo?: string | string[]
    children: ReactNode
    question?: string
    skipCallback?: React.Dispatch<React.SetStateAction<string>>
    subtext?: string
    skipText?: string
}

interface SkipCheckboxProps {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    callback: React.Dispatch<any>
    skipText?: string
}

const SkipButton: React.FC<SkipCheckboxProps> = ({
    callback,
    skipText,
}: SkipCheckboxProps) => (
    <FormControlLabel
        onChange={callback}
        id={'skipCheckbox'}
        label={skipText ?? 'Skip, this does not apply to me'}
        control={<Checkbox />}
    />
)

const IntakeCard: React.FC<Props> = ({
    additionalInfo,
    children,
    question,
    skipCallback,
    subtext,
    skipText,
}: Props) => {
    return (
        <Box sx={{ flex: 1, marginTop: getPxAsRem(24) }}>
            {question && (
                <Typography variant="h4" component="h1">
                    {question}
                </Typography>
            )}

            {subtext && (
                <Subtext subtext={subtext} additionalInfo={additionalInfo} />
            )}

            {children}

            {skipCallback && (
                <SkipButton callback={skipCallback} skipText={skipText} />
            )}
        </Box>
    )
}

export default IntakeCard
